var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import gsap from 'gsap';
import parse from 'html-react-parser';
import './TwoColumnMultipleImage.scss';
import useViewport from '../../hooks/useViewport';
var TwoColumnMultipleImage = function (_a) {
    var _b = _a.data, imageMenu = _b.imageMenu, cta = _b.cta;
    var visualViewport = useViewport().visualViewport;
    var isTablet = visualViewport.width < 1024 && visualViewport.width >= 768;
    var isDesktop = visualViewport.width >= 1024;
    var isMobile = window.visualViewport.width < 768;
    useEffect(function () {
        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: '.two-column-multiple-image',
                start: 'top center',
            },
        });
        tl.fromTo('.two-column-multiple-image__row ', {
            opacity: 0,
            duration: 0.5,
            stagger: 0.5,
        }, {
            opacity: 1,
            duration: 0.5,
            stagger: 0.5,
        });
    }, []);
    return (_jsx("div", __assign({ className: " two-column-multiple-image max-full lg:snap-center md:snap-start snap-start items-center", style: {
            paddingBottom: "" + (isDesktop ? "128px" : isTablet ? "80px" : isMobile ? "64px" : ''),
        } }, { children: _jsx("div", __assign({ className: "two-column-multiple-image__flexWrapper flex flex-col text-enblue" }, { children: imageMenu.map(function (item, index) {
                return (_jsxs("ul", __assign({ className: "two-column-multiple-image__row w-full flex" }, { children: [_jsxs("li", __assign({ className: "two-column-multiple-image__imageWrapper relative md:w-1/2" }, { children: [item.image && (_jsx("img", { className: "two-column-multiple-image__image", src: item.image.src, alt: item.image.alt }, void 0)),
                                index < imageMenu.length - 1 && isMobile && (_jsx("hr", { className: "divisor", style: {
                                        borderTop: 'solid 1px #005f9e',
                                        width: '0%',
                                    } }, void 0))] }), void 0),
                        _jsxs("li", __assign({ className: "two-column-multiple-image__contentWrapper w-3/4 md:w-1/2 flex flex-col text-center relative" }, { children: [_jsx("p", __assign({ className: "two-column-multiple-image__header font-bold" }, { children: item.header }), void 0),
                                item.body && (_jsx("div", __assign({ className: "two-column-multiple-image__body" }, { children: parse(item.body) }), void 0)),
                                index < imageMenu.length - 1 && (_jsx("hr", { className: "divisor", style: {
                                        borderTop: 'solid 1px #005f9e',
                                    } }, void 0)),
                                index == imageMenu.length - 1 && cta.label && (_jsxs("div", __assign({ className: "two-column-multiple-image__cta absolute left-0 right-0 space-x-2 text-sm font-semibold bottom-0 flex justify-center" }, { children: [_jsx("a", __assign({ href: cta.url, role: "button", className: "two-column-multiple-image__cta-url" }, { children: cta.label }), void 0),
                                        _jsxs("svg", __assign({ className: "w-4 stroke-current", viewBox: "0 0 16 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("path", { d: "M1 6.09433H13.35", strokeWidth: "1.5", strokeLinecap: "square", strokeLinejoin: "round" }, void 0),
                                                _jsx("path", { d: "M10.1523 1.74829L14.4497 6.00009L10.1523 10.2519", strokeWidth: "1.5", strokeLinecap: "square", strokeLinejoin: "round" }, void 0)] }), void 0)] }), void 0))] }), void 0)] }), item.header));
            }) }), void 0) }), void 0));
};
export default TwoColumnMultipleImage;
